// Generated by CoffeeScript 2.7.0
var RedPacketSetting;

import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

export default RedPacketSetting = {
  components: {
    'datetime-picker': DateTimePickerPopover
  },
  props: {
    initialSettings: Object,
    // private limit
    min_amount: {
      type: Number,
      default: 1.0
    },
    max_amount: {
      type: Number,
      default: 1.0
    }
  },
  data: function() {
    return {
      total_amount: 0.0,
      available_amount: 0.0,
      enable: !_.isEmpty(this.initialSettings),
      random: Boolean(this.initialSettings.random),
      red_packet_setting: _.extend({
        act_name: '',
        wishing: '',
        remark: '',
        send_name: _global.namespace.name,
        per_amount: 1.0,
        begin_per_amount: this.min_amount,
        end_per_amount: this.max_amount,
        total_num: null,
        expired_at: null
      }, _.omit(this.initialSettings, '_destroy', 'random'))
    };
  },
  template: `<div class="red_packet-setting">
  <div class="setting-header">
    <h4>红包总额度{{ total_amount }}元，剩余额度{{ available_amount }}元</h4>
    <div class="switch-box">
      <label class="switch">
        <input type="checkbox" v-model='enable' />
        <span></span>
      </label>
      <span class="switch-text">开启红包</span>
    </div>
  </div>
  <div class="setting-body" :class="{'disabled': !enable}">
    <label class="option-item">
      <input type="checkbox" hidden='true' :checked='random' v-model='random' />
      <i class="slp-square-o"></i>
      <span class="option-label">
        <span>随机</span>
        <span class="slp-tooltip right" data-title='开启随机将会从最小金额到最大金额中随机一个红包进行发送'>
          <i class="slp-question"></i>
        </span>
      </span>
    </label>
    <div class="form-field-group inline">
      <div class="form-field required has-helper" v-show='!random'>
        <div class="form-field-head">
          <div class="form-field-title">单个金额</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="number" class="form-field-value" v-model='red_packet_setting.per_amount' placeholder='请输入' />
          </div>
          <div class="message">单位元，精确到分</div>
        </div>
      </div>
      <div class="form-field has-helper" v-show='random'>
        <div class="form-field-head">
          <div class="form-field-title">单个最小金额</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="number" class="form-field-value" v-model='red_packet_setting.begin_per_amount' placeholder='请输入' />
          </div>
          <div class="message">单位元，精确到分</div>
        </div>
      </div>
      <div class="form-field has-helper" v-show='random'>
        <div class="form-field-head">
          <div class="form-field-title">单个最大金额</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="number" class="form-field-value" v-model='red_packet_setting.end_per_amount' placeholder='请输入' />
          </div>
          <div class="message">单位元，精确到分</div>
        </div>
      </div>
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">个数</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="number" class="form-field-value" v-model='red_packet_setting.total_num' placeholder='默认不限制个数' />
          </div>
        </div>
      </div>
    </div>
    <div class="form-field-group">
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">商户名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="text" class="form-field-value" v-model.trim='red_packet_setting.send_name' placeholder='默认为空间名' />
          </div>
        </div>
      </div>
      <div class="form-field required">
        <div class="form-field-head">
          <div class="form-field-title">红包祝福语:</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="text" class="form-field-value" v-model.trim='red_packet_setting.wishing' placeholder='请输入' />
          </div>
        </div>
      </div>
      <div class="form-field required">
        <div class="form-field-head">
          <div class="form-field-title">活动名称:</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="text" class="form-field-value" v-model.trim='red_packet_setting.act_name' placeholder='请输入' />
          </div>
        </div>
      </div>
    </div>
    <div class="form-field-group inline">
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">过期时间</div>
        </div>
        <div class="form-field-input-container">
          <datetime-picker position='top'
                           :initValue='expired_at'
                           @valueChanged='updateExpiredAt' />
        </div>
      </div>
      <div class="form-field"></div>
    </div>
  </div>
</div>`,
  created: function() {
    return this._getRedpacketInfo();
  },
  computed: {
    expired_at: function() {
      return this.red_packet_setting.expired_at && new Date(this.red_packet_setting.expired_at);
    }
  },
  methods: {
    _getRedpacketInfo: function() {
      return ({total_amount: this.total_amount, available_amount: this.available_amount} = $currentController.getVars('red_packet_quota'));
    },
    getData: function() {
      return _.extend({
        random: this.random,
        _destroy: !this.enable
      }, this.red_packet_setting);
    },
    updateExpiredAt: function(date) {
      return this.red_packet_setting.expired_at = date.strftime('YYYY-MM-DD hh:mm');
    }
  }
};
